/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nftdetail.vue?vue&type=template&id=733bf67e&scoped=true"
import script from "./nftdetail.vue?vue&type=script&lang=js"
export * from "./nftdetail.vue?vue&type=script&lang=js"
import style0 from "./nftdetail.vue?vue&type=style&index=0&id=733bf67e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733bf67e",
  null
  
)

export default component.exports